import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

//
import { Col, Row, Card } from "react-bootstrap";

//
import PageHeader from "../../components/general/PageHeader";
import UserPortfolios from "../../components/portfolio/UserPortfolios";
import BalanceChartBox from "../../components/portfolio/BalanceChartBox";
import BoxLoading from "../../components/general/BoxLoading";

//
import {
  getPortfolios,
  deletePortfolio,
} from "../../redux/features/portfolio/actions";

import {
  setPortfolios,
  setActivePortfolio,
} from "../../redux/features/portfolio/slice";


function Portfolio({
  portfolios,
  setPortfolios,
  activePortfolio,
  setActivePortfolio,
}) {
  const [loading, setLoading] = useState(false);

  /**
   * Get User Portfolios
   */
  const get_portfolios = async () => {
    // start loading
    setLoading(true);

    // request
    await getPortfolios().then((res) => {
      if (res) {
        setPortfolios(res);

        if (res.length) {
          setActivePortfolio(res[0]);
        }
      }
    });

    // stop loading
    setLoading(false);
  };

  useEffect(() => {
    get_portfolios();

    // eslint-disable-next-line
  }, []);

  return (
    <div id="portfolio">
      <PageHeader title="Portfolio Manager" />

      <div className="position-relative">
      {loading && <BoxLoading />}

        <Row>
          <Col md={4} xl={3} className="gutter-b">
            <UserPortfolios />
          </Col>

          <Col md={8} xl={9}>
            <Card className="content">
              <BalanceChartBox />
            </Card>
          </Col>
        </Row>
      </div>
    </div>
  );
}

const mapDispatchToProps = {
  setPortfolios,
  setActivePortfolio,
};

const mapStateToProps = (state) => ({
  portfolios: state.portfolioReducer.portfolios,
  activePortfolio: state.portfolioReducer.activePortfolio,
});

export default connect(mapStateToProps, mapDispatchToProps)(Portfolio);
